import { IApplicationState } from '../types/redux';

export function getDealType(state: IApplicationState) {
  return state.filters.dealType;
}
